import { Link } from "react-router-dom";

export default function PageHero({ eyebrow, title, subtitle, image, imageAlt, testId = "page-hero" }) {
  return (
    <section className="relative border-b border-[color:var(--border)]" data-testid={testId}>
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-14 py-16 md:py-24 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7 fade-up">
          {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
          <h1 className="display-xl">{title}</h1>
          {subtitle && (
            <p className="mt-6 text-lg text-[color:var(--muted)] max-w-xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
        {image && (
          <div className="md:col-span-5 fade-up delay-1">
            <div className="aspect-[4/5] overflow-hidden rounded-2xl border border-[color:var(--border)] shadow-sm">
              <img src={image} alt={imageAlt || ""} className="w-full h-full object-cover" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
